import * as misc from "@otto-ec/global-resources/misc";
import * as device from "@otto-ec/global-resources/device";

import * as util from "./beacon-util";
import {
  IMetric,
  isToggleActive,
  METRIC_TYPE,
  normalizeBrowser,
  RawUserTimingData,
  TOGGLE_SEND_TO_ELK,
  UserTimingData,
} from "./beacon-util";
import { trackingEndpointLogic } from "../tracking/tracking";
import { userTimingArray } from "../config/filter-list";

export const toggleNameUserTimings = "bs_send_user_timings";

/**
 *
 */
export async function mergeRumData(
  metricData: RawUserTimingData,
): Promise<UserTimingData | undefined> {
  try {
    const mergedData: UserTimingData = {
      beaconType: "userTiming",
      deviceBrowser: normalizeBrowser(device.browser),
      deviceOS: device.os,
      pageCluster: misc.getPagecluster() ?? "unknown",
      requestTime: Date.now(),
      rumMetrics: util.filterByAllowedNames(
        metricData,
        userTimingArray,
      ) as unknown as IMetric[],
      rum_deviceType: device.type,
      rum_supportsTouch: (await device.getPointerType()).isTouchable,
    };

    if (isToggleActive(TOGGLE_SEND_TO_ELK)) {
      const tsBctElement = window.document.querySelector(".ts-bct");
      const sfid = tsBctElement
        ? tsBctElement.getAttribute("data-ts_sfid")!
        : "";

      mergedData.url = window.location.href;
      mergedData.rum_sfid = sfid;
    }

    return mergedData;

    /*                                                         */
  } catch (e) {
    /*                    */
  }
}

/**
 *
 */
export const beaconServicePathUserTiming = `${util.beaconServicePath}userTiming`;

/**
 *
 */
export async function sendUserTimingsToBeacon(
  metricData: RawUserTimingData,
): Promise<void> {
  util.sendValidBeacon(
    await mergeRumData(metricData),
    beaconServicePathUserTiming,
    toggleNameUserTimings,
    METRIC_TYPE.userTiming,
  );
}

/**
 */
export function sendBeacon(metricData: RawUserTimingData): Promise<unknown> {
  return Promise.all([
    sendUserTimingsToBeacon(metricData),
    trackingEndpointLogic(metricData),
  ]);
}
